<dx-responsive-box
  #textCommunicationContainer
  class="text-communication-container"
>
  <dxi-row></dxi-row>
  <dxi-row></dxi-row>
  <dxi-row></dxi-row>
  <dxi-row></dxi-row>
  <dxi-row></dxi-row>
  <dxi-row></dxi-row>
  <dxi-row></dxi-row>
  <dxi-row></dxi-row>

  <dxi-col></dxi-col>
  <dxi-col></dxi-col>
  <dxi-col screen="md lg"></dxi-col>

  <ng-container *ngIf="!isUserCreated">
    <!-- Subtitle -->
    <dxi-item>
      <dxi-location
        screen="md lg"
        [row]="0"
        [col]="0"
        [colspan]="3"
      ></dxi-location>
      <dxi-location
        screen="xs sm"
        [row]="0"
        [col]="0"
        [colspan]="2"
      ></dxi-location>
      <div *dxTemplate class="input-container">
        <div class="input-wrapper subtitle-container">
          Receive quick community updates by text. Enter a mobile number and set
          your preferences, standard carrier rates may apply.
        </div>
      </div>
    </dxi-item>

    <!-- Standard Notices -->
    <dxi-item>
      <dxi-location
        screen="md lg"
        [row]="1"
        [col]="0"
        [colspan]="3"
      ></dxi-location>
      <dxi-location
        screen="xs sm"
        [row]="1"
        [col]="0"
        [colspan]="2"
      ></dxi-location>
      <div *dxTemplate class="input-container">
        <div class="input-wrapper preference-section">
          <div class="preference-header">
            <dx-switch
              class="switch-input"
              [(value)]="standardNoticesEnabled"
              (onValueChanged)="onNotificationToggleChanged()"
            ></dx-switch>
          </div>
          <div class="preference-title">Standard Notices</div>
          <div class="preference-description">
            Receive standard community notices that share upcoming events and
            updates like National Night Out or new pool hours.
          </div>
        </div>
      </div>
    </dxi-item>

    <!-- Emergency Notices -->
    <dxi-item>
      <dxi-location
        screen="md lg"
        [row]="2"
        [col]="0"
        [colspan]="3"
      ></dxi-location>
      <dxi-location
        screen="xs sm"
        [row]="2"
        [col]="0"
        [colspan]="2"
      ></dxi-location>
      <div *dxTemplate class="input-container">
        <div class="input-wrapper preference-section">
          <div class="preference-header">
            <dx-switch
              class="switch-input"
              [(value)]="emergencyNoticesEnabled"
              (onValueChanged)="onNotificationToggleChanged()"
            ></dx-switch>
          </div>
          <div class="preference-title">Emergency Notices</div>
          <div class="preference-description">
            Receive emergency communications that provide urgent updates such as
            freeze warnings, boil water notices, or community road and facility
            closures.
          </div>
        </div>
      </div>
    </dxi-item>

    <!-- Mobile Number (visible only when at least one notification is enabled) -->
    <dxi-item>
      <dxi-location
        screen="md lg"
        [row]="3"
        [col]="0"
        [colspan]="3"
      ></dxi-location>
      <dxi-location
        screen="xs sm"
        [row]="3"
        [col]="0"
        [colspan]="2"
      ></dxi-location>
      <div *dxTemplate class="input-container">
        <div *ngIf="isAnyNotificationEnabled" class="input-wrapper">
          <div class="field-label">
            Mobile Number
            <span class="required-asterisk">*</span>
          </div>
          <dx-text-box
            class="text-input"
            [ngClass]="{ 'text-input-error': showErrorMessage }"
            mode="tel"
            mask="(X00) 000-0000"
            [maskRules]="phoneRules"
            [(value)]="mobileNumber"
            (onValueChanged)="onMobileNumberChanged()"
          ></dx-text-box>
          <div *ngIf="showErrorMessage" class="field-validation-error">
            {{ errorMessage }}
          </div>
        </div>
      </div>
    </dxi-item>

    <!-- Back Button -->
    <dxi-item>
      <dxi-location
        screen="md lg"
        [row]="4"
        [col]="0"
        [colspan]="3"
      ></dxi-location>
      <dxi-location
        screen="xs sm"
        [row]="4"
        [col]="0"
        [colspan]="2"
      ></dxi-location>
      <div *dxTemplate class="btn-wrapper">
        <dx-button
          text="Back"
          class="back-button"
          type="default"
          (onClick)="btnPreviousClick()"
        ></dx-button>
      </div>
    </dxi-item>

    <!-- Complete Registration Button -->
    <dxi-item>
      <dxi-location
        screen="md lg"
        [row]="5"
        [col]="0"
        [colspan]="3"
      ></dxi-location>
      <dxi-location
        screen="xs sm"
        [row]="5"
        [col]="0"
        [colspan]="2"
      ></dxi-location>
      <div *dxTemplate class="btn-wrapper">
        <dx-button
          text="Complete Registration"
          class="done-button"
          type="default"
          (onClick)="btnRegisterClick()"
        ></dx-button>
      </div>
    </dxi-item>

    <!-- Sign In Link -->
    <dxi-item>
      <dxi-location
        screen="md lg"
        [row]="6"
        [col]="0"
        [colspan]="3"
      ></dxi-location>
      <dxi-location
        screen="xs sm"
        [row]="6"
        [col]="0"
        [colspan]="2"
      ></dxi-location>
      <div *dxTemplate class="signin-container">
        <span>
          Already have an account?
          <a (click)="btnBackToLogin()">Sign in</a>
        </span>
      </div>
    </dxi-item>
  </ng-container>

  <ng-container *ngIf="isUserCreated">
    <dxi-item>
      <dxi-location
        screen="md lg"
        [row]="0"
        [col]="0"
        [colspan]="3"
      ></dxi-location>
      <dxi-location
        screen="xs sm"
        [row]="0"
        [col]="0"
        [colspan]="2"
      ></dxi-location>
      <div *dxTemplate class="success-container">
        <div class="success-icon">
          <i class="fas fa-check-circle"></i>
        </div>
        <div class="success-message-primary">
          Your account registration has been completed.
        </div>
        <div class="success-message-secondary">
          We have sent you a confirmation email, please follow the steps to
          activate your account. Make sure to check your Spam folder in your
          inbox.
        </div>
        <div class="success-message-action">
          After activation, you may then
          <a (click)="btnBackToLogin()">sign in</a>
          to your account.
        </div>
      </div>
    </dxi-item>
  </ng-container>
</dx-responsive-box>

<dx-load-panel
  #loadPanelLogin
  shadingColor="rgba(0,0,0,0.4)"
  [position]="{ of: '#textCommunicationContainer' }"
  [(visible)]="loadingVisible"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  [hideOnOutsideClick]="false"
></dx-load-panel>

<cc-message-box #messageBox></cc-message-box>
